module.exports = __webpack_public_path__ + "files/c7b5df0ef05c3fb57d8a5cf488c6f73b.png";